// Package details (matches contract)
export const PACKAGES = [
  { id: 1, price: 8, label: "Package 1", color: "#22d3ee" },
  { id: 2, price: 18, label: "Package 2", color: "#a855f7" },
  { id: 3, price: 26, label: "Package 3", color: "#e879f9" },
  { id: 4, price: 48, label: "Package 4", color: "#f472b6" },
  { id: 5, price: 68, label: "Package 5", color: "#fb7185" },
  { id: 6, price: 88, label: "Package 6", color: "#fbbf24" },
  { id: 7, price: 188, label: "Package 7", color: "#34d399" },
  { id: 8, price: 444, label: "Package 8", color: "#c084fc" },
];

// Activity types (matches contract)
export const ACTIVITY_TYPES = {
  1: { label: "Registered", icon: "👋", color: "#22d3ee" },
  2: { label: "Package Activated", icon: "✨", color: "#a855f7" },
  3: { label: "Package Re-topped Up", icon: "🔄", color: "#c084fc" },
  4: { label: "Direct Income", icon: "💰", color: "#34d399" },
  5: { label: "Matrix Income", icon: "🎯", color: "#e879f9" },
  6: { label: "Royalty Claimed", icon: "☀️", color: "#fbbf24" },
  9: { label: "Ceiling Upgraded", icon: "⬆️", color: "#34d399" },
  10: { label: "Ceiling Hit", icon: "🚧", color: "#fb7185" },
  11: { label: "Blocked", icon: "🚫", color: "#f43f5e" },
  12: { label: "Unblocked", icon: "✅", color: "#34d399" },
  13: { label: "Name Updated", icon: "📝", color: "#a855f7" },
  14: { label: "Wallet Updated", icon: "🔑", color: "#22d3ee" },
};

// Admin activity types (matches contract enum values 20-33 + 40-48)
export const ADMIN_ACTIVITY_TYPES = {
  20: { label: "Virtual Register",       icon: "◇",  color: "#00e5ff" },
  21: { label: "Admin Activate",         icon: "✨", color: "#7df9ff" },
  22: { label: "Admin Retopup",          icon: "🔄", color: "#a78bfa" },
  23: { label: "Blocked User",           icon: "🚫", color: "#ff4d6d" },
  24: { label: "Unblocked User",         icon: "✓",  color: "#22ffa0" },
  25: { label: "Updated Name",           icon: "📝", color: "#b855ff" },
  26: { label: "Updated Wallet",         icon: "🔑", color: "#00e5ff" },
  27: { label: "Set Royalty Round",      icon: "☀",  color: "#ec4899" },
  31: { label: "Updated Team Wallet",    icon: "💼", color: "#7df9ff" },
  32: { label: "Updated Missing Wallet", icon: "💼", color: "#7df9ff" },
  33: { label: "Emergency Withdraw",     icon: "🚨", color: "#ff4d6d" },
  40: { label: "Set Migrator",           icon: "⚙",  color: "#a78bfa" },
  41: { label: "Locked Migration",       icon: "🔒", color: "#fbbf24" },
  42: { label: "Migrated: Register",     icon: "📥", color: "#00e5ff" },
  43: { label: "Migrated: Activate",     icon: "📥", color: "#7df9ff" },
  44: { label: "Migrated: Retopup",      icon: "📥", color: "#a78bfa" },
  45: { label: "Migrated: Direct Count", icon: "📥", color: "#22ffa0" },
  46: { label: "Migrated: Income",       icon: "📥", color: "#ec4899" },
  47: { label: "Migrated: Claimed",      icon: "📥", color: "#fbbf24" },
  48: { label: "Migration State",        icon: "📥", color: "#a78bfa" },
};

export const DEFAULT_REFERRER_ID = 100000;
export const MATRIX_LEVELS = 8;
export const MAX_ACTIVITIES = 100;

// ============================================================
// Deterministic income amount → source package lookup
// Every package has a FIXED direct-income (45%) and per-level
// matrix-income (5%) value. Since each of these 16 amounts is
// unique (no collisions), we can identify the source package
// of any income entry from the amount alone — no event scan.
// ============================================================
// Map key: amount in USDT-wei (18 decimals) as a decimal string
// Map value: packageId (1..8) as a string
export const INCOME_AMOUNT_TO_PACKAGE = {
  // P1 ($8)   — direct 3.6, matrix 0.4
  "3600000000000000000":   "1",
  "400000000000000000":    "1",
  // P2 ($18)  — direct 8.1, matrix 0.9
  "8100000000000000000":   "2",
  "900000000000000000":    "2",
  // P3 ($26)  — direct 11.7, matrix 1.3
  "11700000000000000000":  "3",
  "1300000000000000000":   "3",
  // P4 ($48)  — direct 21.6, matrix 2.4
  "21600000000000000000":  "4",
  "2400000000000000000":   "4",
  // P5 ($68)  — direct 30.6, matrix 3.4
  "30600000000000000000":  "5",
  "3400000000000000000":   "5",
  // P6 ($88)  — direct 39.6, matrix 4.4
  "39600000000000000000":  "6",
  "4400000000000000000":   "6",
  // P7 ($188) — direct 84.6, matrix 9.4
  "84600000000000000000":  "7",
  "9400000000000000000":   "7",
  // P8 ($444) — direct 199.8, matrix 22.2
  "199800000000000000000": "8",
  "22200000000000000000":  "8",
};

// Club rank names
export const DAILY_CLUB_NAMES = {
  1: "Starter",
  2: "Builder",
  3: "Achiever",
  4: "Leader",
  5: "Mentor",
  6: "Director",
  7: "Executive",
};

// Weekly / Monthly clubs removed in the new contract split.
// The 7 daily royalties above are now the entire rank ladder.
